export const deliveryServiceConfig = {
  adminApi: process.env.REACT_APP_CPD_ADMIN_API,
  adminApiV2: process.env.REACT_APP_CPD_ADMIN_API_V2,
  projectApi: process.env.REACT_APP_CPD_PROJECT_API,
  projectApiV4: process.env.REACT_APP_CPD_PROJECT_API_V4,
  projectApplicationUrl: process.env.REACT_APP_PROJECT_APPLICATION_URL
};
